module.exports = __webpack_public_path__ + "static/media/splatter.7f985a90.jpg";